var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jwnet-edi-application-form',{attrs:{"tenant":_vm.tenant}})
}
var staticRenderFns = []

export { render, staticRenderFns }